module.exports = __webpack_public_path__ + "img/ac4a10a7fd36ef556092b071005fc92f.svg";